namespace SPA
{
	export namespace gui
	{
		export namespace address
		{
			export class AddressSection extends ui.base.BaseHTMLElement
			{

				private m_Orga:		Organization.gui.OrgaTree;
				private m_Object: Wollmilch.RecipientObject;

				public constructor( obj: Wollmilch.RecipientObject, orga: Organization.gui.OrgaTree )
				{
					super( 'div' );

					this.m_Orga		= orga;
					this.m_Object	= obj;
				}

				public SetRecipient( rec: Wollmilch.RecipientObject ): void { this.m_Object = rec; }

				public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement> ): AddressSection
				{
					this.empty().addClass('row');

					if ( root )
					{
						this.remove();

						this.appendTo( root );
					}

					// Assume at most one address part for each purpose
					const adr = this.m_Object.Address.find((a) => {
						return a.AddressType === 'PostalAddress';
					}) as Wollmilch.PostalAddressObject;
					const email = this.m_Object.Address.find((a) => a.AddressType === 'Email') as Wollmilch.EmailAddressObject;
					const phone = this.m_Object.Address.find((a) => a.AddressType === 'Phone' && a.KindOf === 'cell') as Wollmilch.PhoneAddressObject;
					const mobile = this.m_Object.Address.find((a) => a.AddressType === 'Phone' && a.KindOf === 'mobile') as Wollmilch.PhoneAddressObject;

					const stateSelect = new ui.Form.Select(
						{
							name: 'address.state',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.Address.State)
						}, adr && adr.State ? adr.State : undefined
					);
					stateSelect.Initialize();

					const previewArea = $(`<div class="doc-preview">
								<img class="doc-placeholder" src="assets/images/placeholder-image.png" alt="">
								<input type="file" name="image" class="hidden">
							</div>`).on('dragover drop', (e: JQuery.TriggeredEvent) => {
						e.preventDefault();

						if (e.type === 'dragover') {
							// We have to capture dragover and drop for d&d to work
							return;
						}

						// Single file only
						if (e.originalEvent.dataTransfer.files.length !== 1) {
							return;
						}

						const file = e.originalEvent.dataTransfer.files[0];
						this.uploadImage(file, this.m_Object.ID);
					}).on('change', 'input[name=image]', (e) => {
						if (e.currentTarget.files.length !== 1) {
							return;
						}
						const file = e.currentTarget.files[0];
						this.uploadImage(file, this.m_Object.ID);
					});

					const contactSection = ui.$$.div();
					let formSize = 10;
					switch (this.m_Object.Type)
					{
						case 'Employee':
							// const uploadPictureBtn = $('<button class="btn btn-link pull-right">Neues Bild</button>')
							// 	.on('click', (e) => {
							// 		previewArea.find('input[name=image]').trigger('click');
							// 	});

							// this.append($('<div class="form-group col-sm-2">')
							// 	.append('<label>Mitarbeiter-Bild</label>')
							// 	.append(previewArea)
							// 	.append(uploadPictureBtn)
							// );
							if (this.m_Object.StaffNumber === "null" || this.m_Object.StaffNumber === null) {
								this.m_Object.StaffNumber = "";
							}
							contactSection.append(`
								<div class="form-group col-sm-3">
									<label>Mitarbeiter-Nr.</label>
									<input class="form-control" type="text" name="component.staff_number" value="${this.m_Object.StaffNumber}">
								</div>
								<div class="form-group col-sm-8">
									<label>angelegt am</label>
									<p class="form-control-static">${moment(this.m_Object.CreatedAt.date).format('DD.MM.YYYY, HH:mm') + ' Uhr'}</p>
								</div>
								<div class="form-group col-sm-3">
									<label>Anrede</label>
									<select class="form-control" name="component.salutation">
										<option value="MR">Herr</option>
										<option value="MRS">Frau</option>
									</select>
								</div>
								<div class="form-group col-sm-3">
									<label>Vorname</label>
									<input class="form-control" type="text" name="component.name" value="${this.m_Object.Name}">
								</div>
								<div class="form-group col-sm-5">
									<label>Nachname</label>
									<input class="form-control" type="text" name="component.surname" value="${this.m_Object.Surname}">
								</div>`
							);
							break;
						case 'Department':
							formSize = 12;
							contactSection.append(`
								<div class="form-group col-sm-4">
									<label>Abteilung</label>
									<input class="form-control" type="text" name="component.name" placeholder="Abteilungsname" value="${this.m_Object.Name}">
								</div>
								<div class="form-group col-sm-3">
									<label>Kürzel</label>
									<input class="form-control" type="text" name="component.identifier" value="${this.m_Object.Identifier}">
								</div>
								<div class="form-group col-sm-4">
									<label>angelegt am</label>
									<p class="form-control-static">${moment(this.m_Object.CreatedAt.date).format('DD.MM.YYYY, HH:mm') + ' Uhr'}</p>
								</div>`
							);
							break;
						case 'Company':
							// const uploadLogoBtn = $('<button class="btn btn-link pull-right">Neues Logo</button>')
							// 	.on('click', (e) => {
							// 		previewArea.find('input[name=logo]').trigger('click');
							// 	});

							// this.append($('<div class="form-group col-sm-2">')
							// 	.append('<label>Firmen-Logo</label>')
							// 	.append(previewArea)
							// 	.append(uploadLogoBtn)
							// );

							contactSection.append(`
								<div class="form-group col-sm-5">
									<label>Firma</label>
									<input class="form-control" type="text" name="component.name" placeholder="Firmenname" value="${this.m_Object.Name}">
								</div>
								<div class="form-group col-sm-2">
									<label>Rechtsform</label>
									<input class="form-control" type="text" name="component.legal_form" value="${this.m_Object.LegalForm}">
								</div>
								<div class="form-group col-sm-2">
									<label>Abkürzung</label>
									<p class="form-control-static">${this.m_Object.Shortcut}</p>
								</div>
								<div class="form-group col-sm-3">
									<label>angelegt am</label>
									<p class="form-control-static">${moment(this.m_Object.CreatedAt.date).format('DD.MM.YYYY, HH:mm') + ' Uhr'}</p>
								</div>`
							);
							break;
					}

					// const addressForm = $(`<form class="col-sm-${formSize}">`)
					const addressForm = $(`<form class="col-sm-12">`)
						.on('submit', (e) => this.onFormSubmit(e));

					this.append(
						addressForm.append(
							contactSection.add(`
								<div class="form-group col-sm-8 col-md-8">
									<label>Straße</label>
									<input class="form-control" type="text" name="address.street" value="${adr && adr.Street ? adr.Street : ''}">
								</div>
								<div class="form-group col-sm-4 col-md-4">
									<label>Hausnummer</label>
									<input class="form-control" type="text" name="address.housenumber" value="${adr && adr.HouseNumber ? adr.HouseNumber :  ''}">
								</div>
								<div class="form-group col-sm-3 col-md-2">
									<label>PLZ</label>
									<input class="form-control" type="text" name="address.postalcode" value="${adr && adr.PostalCode ? adr.PostalCode : ''}">
								</div>
								<div class="form-group col-sm-4 col-md-5">
									<label>Ort</label>
									<input class="form-control" type="text" name="address.city" value="${adr && adr.City ? adr.City : ''}">
								</div>`
							)
						)
						.append($('<div class="form-group col-sm-5">')
							.append('<label>Bundesland</label>')
							.append(stateSelect.Input())
						)
						.append($(`
							<div class="form-group col-sm-4">
								<label>E-Mail</label>
							<input type="hidden" name="email.id" value="${email ? email.ID : ''}">
								<input type="text" class="form-control" name="email.value" value="${email ? email.display : ''}">
							</div>
							<div class="form-group col-sm-4">
								<label>Telefon</label>
								<input type="hidden" name="phone.id" value="${phone ? phone.ID : ''}">
								<input type="text" class="form-control" name="phone.value" value="${phone ? phone.display : ''}">
							</div>
							<div class="form-group col-sm-4">
								<label>Mobil</label>
								<input type="hidden" name="mobile.id" value="${mobile ? mobile.ID : ''}">
								<input type="text" class="form-control" name="mobile.value" value="${mobile ? mobile.display : ''}">
							</div>
							<input type="hidden" name="component.id" value="${this.m_Object.ID}">
							<input type="hidden" name="address.id" value="${adr ? adr.ID : ''}">`
						))
						.append(
							ui.$$.div().addClass('col-xs-12')
								.append($('<button class="btn btn-primary btn-orga-save"><i class="fa fa-save"></i> Daten speichern</button>'))
						)
					);

					// this.m_Object.Address.forEach( ( addr: Wollmilch.AddressObject ) => new AddressItem( addr ).rebuild( this ) );

					return this;
				}

				private onFormSubmit(e: JQuery.TriggeredEvent)
				{
					e.preventDefault();

					const data: { [key: string]: any } = {};
					const formElements = (e.currentTarget as HTMLFormElement).elements;
					for (let i = 0; i < formElements.length; i++)
					{
						const element = formElements[i] as HTMLInputElement;
						if (element.name === '') {
							continue;
						}

						const nameParts = element.name.split('.');
						if (nameParts.length === 2)
						{
							if (data[nameParts[0]] === undefined) {
								data[nameParts[0]] = {};
							}
							data[nameParts[0]][nameParts[1]] = element.value;
						}
					}

					new Wollmilch.AJAX({
						url: 'organization/update/' + this.m_Object.ID,
						method: 'PATCH',
						contentType: 'application/json',
						data,
						on: {
							success: (text: string) => {
								const _obj = JSON.parse(text);
								if (!_obj.success) {
									app.addNotify(
										{
											body: [ui.text('Fehler beim Aktualisieren der Organisationsdaten')],
											context: 'warning',
											timeout: Number(app.getConfigValue("ToastTimeout")),
											title: [ui.h(3, 'Aktualisierungsfehler')],
										},
									);
									return;
								}

								switch (_obj.data.Type) {
									case 'Company':
										app.getAuthenticationManager().setCompany(_obj.data);
										break;
									case 'Department':
										break;
									case 'Employee':
										app.getAuthenticationManager().setEmployee(_obj.data);
										break;
								}
								if (_obj.data.Type === 'Company') {
									// location.reload();
									const tabControl = app.getGlobalTabControl();
									tabControl.removeTab(tabControl.getTab('Organisation') as ui.tab.Entry);
									app.getGlobalTabControl().addTab( 'Organisation', new SPA.Organization.gui.OrgaTree( app.getAuthenticationManager().getCompany() ), true, true );
								} else {
									$('html').trigger('reloadOrgaTree');
									$('html').trigger('accountCreated');
								}

								app.addNotify(
									{
										body: [ 'Daten erfolgreich gespeichert' ],
										title: [ 'Erfolg!' ],
										context: "success",
										timeout: Number(app.getConfigValue("ToastTimeout"))
									}
								);
							}
						}
					}, AJAXCallbase_e.APIV1).send();
				}
				private uploadImage(file: File, componentID?: number)
				{
					if (file.type !== 'image/png' && file.type !== 'image/jpeg')
					{
						alert('Für den Upload sind nur Bilder (png oder jpg) zugelassen.');
						return;
					}
					console.log(file, componentID);
				}
			}
		}
	}
}
